export const getShowChangePassword = (state) => {
	return state.showChangePassword
}